// src/validation/rules.js

import { required, email } from 'vee-validate/dist/rules';

// Define any custom validation rules you need
const customRules = {
    required,
    email,
    // Add other custom rules here
};

export default customRules;
